import Dialog from '../../commons/dialog/Dialog.js';
import * as Utils from '../../commons/utils/Utils';

export const cancelarSolicitud = (intl, solicitud) =>
	Dialog.confirm(intl, {
		title: intl.formatMessage({ id: 'solicitudes.cancelar.confirmar_titulo', defaultMessage: 'Cancelar solicitud' }),
		text: intl.formatMessage({ id: 'solicitudes.cancelar.confirmar_texto', defaultMessage: '¿Confirma que desea cancelar la solicitud {numero}?' }, { numero: solicitud.numero }),
		confirmText: intl.formatMessage({ id: 'solicitudes.cancelar.si', defaultMessage: 'Sí, cancelar' }),
		cancelText: intl.formatMessage({ id: 'solicitudes.cancelar.no', defaultMessage: 'No' }),
	}).then((confirmado) => {
		if (!confirmado) return false;
		return Utils.sendData('/solicitudes/' + solicitud.id + '/cancelar', 'PATCH')
			.then(() => {
				Dialog.alert(intl, {
					icon: 'success',
					title: intl.formatMessage({ id: 'solicitudes.cancelar.ok_titulo', defaultMessage: 'Solicitud cancelada' }),
					text: intl.formatMessage({ id: 'solicitudes.cancelar.ok_texto', defaultMessage: 'La solicitud {numero} fue cancelada.' }, { numero: solicitud.numero }),
				});
				return true;
			})
			.catch(() => false);
	});
